module.exports = "/_next/static/images/333b4590f6f0dfda461bacdca9321b6a-man-looking-up-smiling-md@1x.jpg";